import { render } from "./CalcDeliveryAmount.vue?vue&type=template&id=6623a4c2"
import script from "./CalcDeliveryAmount.vue?vue&type=script&lang=js"
export * from "./CalcDeliveryAmount.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__